<template>
  <div class="loader-parent-container">
    <div :class="['loading', { fixed }]">
      <div class="loading-text" v-if="showLoadingTextWithLoader">
        {{ $t("widgetApp.loading") }}...
      </div>
    </div>
  </div>
</template>

<script>
import viewTypes from "../../views";
import * as helper from "../../helpers";
export default {
  name: "Loader",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    hideLoadingText: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    const documentView = document.documentElement.getAttribute("view") || "";
    return {
      showLoadingTextWithLoader:
        !this.hideLoadingText && viewTypes[documentView]?.showLoadingTextWithLoader,
    };
  },
  mounted() {
    this.showLoadingTextWithLoader =
      this.hideLoadingText &&
      (this.showLoadingTextWithLoader || this.$route.meta.view === "widget");
    if (helper.isAppLoadedInsideIframe())
      helper.sendPostMessageToParentWindow(helper.LOADER_DID_APPEAR, {});
  },
};
</script>

<style lang="scss">
.loading {
  @include page-loader();
  .loading-text {
    padding-top: 50px;
    display: flex;
    justify-content: center;
  }

  &.fixed {
    position: fixed;
  }
}
</style>
